import { render, staticRenderFns } from "./EconomicCalendar.vue?vue&type=template&id=85af219a&scoped=true"
import script from "./EconomicCalendar.vue?vue&type=script&lang=js"
export * from "./EconomicCalendar.vue?vue&type=script&lang=js"
import style0 from "./EconomicCalendar.vue?vue&type=style&index=0&id=85af219a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85af219a",
  null
  
)

export default component.exports